import { TBaseItem } from "@centricsoftware/design-system";
import { DataStoreNamesItemToOptionFunction, ISingleSelectOptionStore } from "csi/components/types";
import { ILocaleProvider } from "designSystem/locale";
import { queryDataStoreNames } from "src/c8-platform/service/dataStoreService";
import { IDataStoreNamesItem, IDataStoreParams } from "src/c8-platform/type/dataStore";

function defaultTransform({ name, url }: IDataStoreNamesItem, loc: ILocaleProvider): TBaseItem {
	return { id: url, name };
}

class DataStoreNamesStore implements ISingleSelectOptionStore {
	/** parameters to use to query data store */
	params: IDataStoreParams;

	/** function that will transform the data store result to an option to override the default */
	resultTransform?: DataStoreNamesItemToOptionFunction;

	/** query data store and produce options */
	query = async (loc: ILocaleProvider): Promise<TBaseItem[]> => {
		const { params, resultTransform = defaultTransform } = this;
		const response = await queryDataStoreNames(params);
		return response.urls.map((item) => resultTransform(item, loc));
	};

	constructor(params: IDataStoreParams, resultTransform?: DataStoreNamesItemToOptionFunction) {
		this.params = params;
		this.resultTransform = resultTransform;
	}
}

export default DataStoreNamesStore;